import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemplateLibrary = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M87.215 56.71C88.35 54.555 89 52.105 89 49.5C89 42.879 84.841 37.243 78.999 35.022C78.999 35.015 79 35.008 79 35C79 23.402 69.598 14 58 14C48.216 14 40.019 20.701 37.687 29.757C36.211 29.272 34.638 29 33 29C25.308 29 18.977 34.793 18.11 42.252C12.906 43.353 9 47.969 9 53.5C9 59.851 14.149 65 20.5 65C20.677 65 20.852 64.988 21.026 64.978C21.022 65.153 21 65.324 21 65.5C21 76.822 30.178 86 41.5 86C47.937 86 53.675 83.028 57.434 78.386C59.612 80.611 62.64 82 66 82C70.65 82 74.674 79.35 76.666 75.482C77.718 75.817 78.837 76 80 76C86.075 76 91 71.075 91 65C91 61.689 89.53 58.727 87.215 56.71Z",
			fill: "#DEF0E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.125 47.5C67.125 47.5 63.485 47.5 61 47.5C58.515 47.5 56.5 45.485 56.5 43C56.5 40.667 58.282 38.771 60.555 38.545C60.533 38.364 60.5 38.187 60.5 38C60.5 35.515 62.515 33.5 65 33.5C66.438 33.5 67.703 34.186 68.527 35.236C68.667 32.6 70.829 30.5 73.5 30.5C76.261 30.5 78.5 32.739 78.5 35.5C78.5 35.946 78.423 36.37 78.313 36.782C78.955 36.005 79.913 35.5 81 35.5C82.781 35.5 84.234 36.835 84.455 38.555C84.636 38.533 84.813 38.5 85 38.5C87.485 38.5 89.5 40.515 89.5 43C89.5 45.485 87.485 47.5 85 47.5C82.515 47.5 75.5 47.5 75.5 47.5H70.125V48H67.125V47.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.5 30C76.533 30 79 32.467 79 35.5C79 35.516 79 35.531 79 35.547C79.602 35.192 80.29 35 81 35C82.831 35 84.411 36.261 84.858 38.005C84.905 38.002 84.952 38 85 38C87.757 38 90 40.243 90 43C90 45.757 87.757 48 85 48H70.125C69.849 48 69.625 47.776 69.625 47.5C69.625 47.224 69.849 47 70.125 47H85C87.206 47 89 45.206 89 43C89 40.794 87.206 39 85 39C84.883 39 84.77 39.017 84.657 39.032L84.516 39.051C84.495 39.054 84.475 39.055 84.454 39.055C84.208 39.055 83.992 38.87 83.959 38.618C83.768 37.125 82.496 36 81 36C80.115 36 79.277 36.401 78.699 37.1C78.601 37.218 78.458 37.282 78.313 37.282C78.235 37.282 78.157 37.264 78.085 37.226C77.876 37.119 77.771 36.88 77.831 36.653C77.946 36.218 78 35.852 78 35.5C78 33.019 75.981 31 73.5 31C71.119 31 69.153 32.872 69.026 35.263C69.015 35.471 68.876 35.65 68.677 35.713C68.627 35.729 68.576 35.737 68.525 35.737C68.375 35.737 68.229 35.668 68.133 35.545C67.362 34.563 66.221 34 65 34C62.794 34 61 35.794 61 38C61 38.117 61.017 38.23 61.032 38.343L61.051 38.484C61.067 38.618 61.029 38.752 60.945 38.857C60.861 38.962 60.738 39.029 60.605 39.042C58.549 39.247 57 40.949 57 43C57 45.206 58.794 47 61 47H67.125C67.401 47 67.625 47.224 67.625 47.5C67.625 47.776 67.401 48 67.125 48H61C58.243 48 56 45.757 56 43C56 40.603 57.689 38.587 60.003 38.123C60.001 38.082 60 38.041 60 38C60 35.243 62.243 33 65 33C66.176 33 67.293 33.416 68.183 34.164C68.781 31.76 70.945 30 73.5 30Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75 37C76.403 37 77.609 37.999 77.913 39.341C78.28 39.119 78.699 39 79.125 39C80.327 39 81.323 39.897 81.478 41.068C81.681 41.022 81.874 41 82.063 41C83.592 41 84.874 42.2 84.981 43.732C84.99 43.87 84.886 43.99 84.749 44C84.743 44 84.737 44 84.731 44C84.601 44 84.491 43.899 84.482 43.768C84.393 42.497 83.331 41.5 82.063 41.5C81.834 41.5 81.593 41.542 81.325 41.627C81.303 41.634 81.28 41.637 81.258 41.637C81.203 41.637 81.148 41.617 81.102 41.583C81.038 41.537 81 41.455 81 41.375C81 40.341 80.159 39.5 79.125 39.5C78.678 39.5 78.24 39.668 77.894 39.973C77.847 40.014 77.788 40.036 77.729 40.036C77.697 40.036 77.666 40.03 77.636 40.017C77.548 39.982 77.488 39.9 77.481 39.805C77.377 38.512 76.288 37.5 75 37.5C74.792 37.5 74.575 37.534 74.318 37.607C74.295 37.614 74.271 37.617 74.248 37.617C74.139 37.617 74.041 37.544 74.009 37.435C73.971 37.302 74.048 37.164 74.181 37.126C74.483 37.04 74.744 37 75 37Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.117 38.5C62.443 38.5 63.625 39.397 63.991 40.682C64.029 40.815 63.952 40.953 63.819 40.991C63.795 40.997 63.772 41 63.75 41C63.641 41 63.541 40.928 63.51 40.818C63.205 39.748 62.221 39 61.117 39C61 39 60.887 39.014 60.775 39.029C60.763 39.031 60.752 39.032 60.74 39.032C60.619 39.032 60.511 38.94 60.494 38.815C60.475 38.678 60.571 38.552 60.708 38.534C60.842 38.516 60.978 38.5 61.117 38.5Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.405 51H5.5C5.224 51 5 50.776 5 50.5C5 50.224 5.224 50 5.5 50H15.405C15.681 50 15.905 50.224 15.905 50.5C15.905 50.776 15.682 51 15.405 51Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 51H17.5C17.224 51 17 50.776 17 50.5C17 50.224 17.224 50 17.5 50H18.5C18.776 50 19 50.224 19 50.5C19 50.776 18.777 51 18.5 51Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.491 53H14.5C14.224 53 14 52.776 14 52.5C14 52.224 14.224 52 14.5 52H23.491C23.767 52 23.991 52.224 23.991 52.5C23.991 52.776 23.767 53 23.491 53Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 53H11.5C11.224 53 11 52.776 11 52.5C11 52.224 11.224 52 11.5 52H12.5C12.776 52 13 52.224 13 52.5C13 52.776 12.777 53 12.5 53Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 53H7.5C7.224 53 7 52.776 7 52.5C7 52.224 7.224 52 7.5 52H9.5C9.776 52 10 52.224 10 52.5C10 52.776 9.777 53 9.5 53Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 55H13.5C13.224 55 13 54.776 13 54.5C13 54.224 13.224 54 13.5 54H15.5C15.776 54 16 54.224 16 54.5C16 54.776 15.776 55 15.5 55Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 46C18.323 46 17.677 46 17.5 46C17.224 46 17 46.224 17 46.5C17 46.776 17.224 47 17.5 47C17.677 47 18.323 47 18.5 47C18.776 47 19 46.776 19 46.5C19 46.224 18.776 46 18.5 46Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 48C18.323 48 13.677 48 13.5 48C13.224 48 13 48.224 13 48.5C13 48.776 13.224 49 13.5 49C13.677 49 18.323 49 18.5 49C18.776 49 19 48.776 19 48.5C19 48.224 18.776 48 18.5 48Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 50C23.323 50 20.677 50 20.5 50C20.224 50 20 50.224 20 50.5C20 50.776 20.224 51 20.5 51C20.677 51 23.323 51 23.5 51C23.776 51 24 50.776 24 50.5C24 50.224 23.776 50 23.5 50Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.5 22H60.5C60.224 22 60 21.776 60 21.5C60 21.224 60.224 21 60.5 21H70.5C70.776 21 71 21.224 71 21.5C71 21.776 70.776 22 70.5 22Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.5 22H72.5C72.224 22 72 21.776 72 21.5C72 21.224 72.224 21 72.5 21H74.5C74.776 21 75 21.224 75 21.5C75 21.776 74.776 22 74.5 22Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.5 24H69.5C69.224 24 69 23.776 69 23.5C69 23.224 69.224 23 69.5 23H79.5C79.776 23 80 23.224 80 23.5C80 23.776 79.777 24 79.5 24Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.5 24H66.5C66.224 24 66 23.776 66 23.5C66 23.224 66.224 23 66.5 23H67.5C67.776 23 68 23.224 68 23.5C68 23.776 67.776 24 67.5 24Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.375 24H62.5C62.224 24 62 23.776 62 23.5C62 23.224 62.224 23 62.5 23H64.375C64.651 23 64.875 23.224 64.875 23.5C64.875 23.776 64.651 24 64.375 24Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.5 20H68.5C68.224 20 68 19.776 68 19.5C68 19.224 68.224 19 68.5 19H73.5C73.776 19 74 19.224 74 19.5C74 19.776 73.777 20 73.5 20Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.5 26H68.5C68.224 26 68 25.776 68 25.5C68 25.224 68.224 25 68.5 25H70.5C70.776 25 71 25.224 71 25.5C71 25.776 70.776 26 70.5 26Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.153 74.3C35.697 74.3 33.7 72.333 33.7 69.915V34.085C33.7 31.667 35.698 29.7 38.153 29.7H56.763L68.3 41.083V69.915C68.3 72.333 66.302 74.3 63.847 74.3H38.153Z",
			fill: "#FEFDEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.477 30.4L60.632 34.499L67.6 41.375V69.915C67.6 71.947 65.916 73.599 63.847 73.599H38.153C36.083 73.599 34.4 71.946 34.4 69.915V34.084C34.4 32.052 36.084 30.4 38.153 30.4H38.901H40.573H45.946H56.477ZM57.051 29H45.947H40.574H38.902H38.154C35.319 29 33 31.288 33 34.084V69.915C33 72.712 35.319 75 38.153 75H63.846C66.681 75 68.999 72.712 68.999 69.916V40.79C64.352 36.205 61.698 33.585 57.051 29Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.5 30.125V35.745C56.5 38.361 58.491 40.5 60.924 40.5H67.125",
			fill: "#FEF6AA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.125 41H60.924C58.209 41 56 38.643 56 35.744V30.125H57V35.744C57 38.091 58.76 40 60.924 40H67.125V41Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.1 72H38.917C37.308 72 36 70.715 36 69.136V35.348C36 33.778 37.301 32.5 38.9 32.5H40.5C40.776 32.5 41 32.724 41 33C41 33.276 40.776 33.5 40.5 33.5H38.9C37.852 33.5 37 34.329 37 35.348V69.136C37 70.164 37.86 71 38.917 71H63.1C64.148 71 65 70.171 65 69.152V55.289C65 55.013 65.224 54.789 65.5 54.789C65.776 54.789 66 55.013 66 55.289V69.152C66 70.723 64.699 72 63.1 72Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.5 53C65.224 53 65 52.776 65 52.5V48.5C65 48.224 65.224 48 65.5 48C65.776 48 66 48.224 66 48.5V52.5C66 52.776 65.776 53 65.5 53Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.5 47C65.224 47 65 46.776 65 46.5V43.5C65 43.224 65.224 43 65.5 43C65.776 43 66 43.224 66 43.5V46.5C66 46.776 65.776 47 65.5 47Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5 45.75H40.5C40.362 45.75 40.25 45.638 40.25 45.5C40.25 45.362 40.362 45.25 40.5 45.25H50.5C50.638 45.25 50.75 45.362 50.75 45.5C50.75 45.638 50.638 45.75 50.5 45.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5 49.75H40.5C40.362 49.75 40.25 49.638 40.25 49.5C40.25 49.362 40.362 49.25 40.5 49.25H50.5C50.638 49.25 50.75 49.362 50.75 49.5C50.75 49.638 50.638 49.75 50.5 49.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5 53.75H40.5C40.362 53.75 40.25 53.638 40.25 53.5C40.25 53.362 40.362 53.25 40.5 53.25H50.5C50.638 53.25 50.75 53.362 50.75 53.5C50.75 53.638 50.638 53.75 50.5 53.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.5 57.75H40.5C40.362 57.75 40.25 57.638 40.25 57.5C40.25 57.362 40.362 57.25 40.5 57.25H47.5C47.638 57.25 47.75 57.362 47.75 57.5C47.75 57.638 47.638 57.75 47.5 57.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.5 61.75H40.5C40.362 61.75 40.25 61.638 40.25 61.5C40.25 61.362 40.362 61.25 40.5 61.25H50.5C50.638 61.25 50.75 61.362 50.75 61.5C50.75 61.638 50.638 61.75 50.5 61.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.5 65.75H40.5C40.362 65.75 40.25 65.638 40.25 65.5C40.25 65.362 40.362 65.25 40.5 65.25H51.5C51.638 65.25 51.75 65.362 51.75 65.5C51.75 65.638 51.638 65.75 51.5 65.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.5 65.75H53.5C53.362 65.75 53.25 65.638 53.25 65.5C53.25 65.362 53.362 65.25 53.5 65.25H61.5C61.638 65.25 61.75 65.362 61.75 65.5C61.75 65.638 61.638 65.75 61.5 65.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.5 57.75H49.5C49.362 57.75 49.25 57.638 49.25 57.5C49.25 57.362 49.362 57.25 49.5 57.25H61.5C61.638 57.25 61.75 57.362 61.75 57.5C61.75 57.638 61.638 57.75 61.5 57.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.5 61.75H57.5C57.362 61.75 57.25 61.638 57.25 61.5C57.25 61.362 57.362 61.25 57.5 61.25H61.5C61.638 61.25 61.75 61.362 61.75 61.5C61.75 61.638 61.638 61.75 61.5 61.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.5 61.75H51.5C51.362 61.75 51.25 61.638 51.25 61.5C51.25 61.362 51.362 61.25 51.5 61.25H55.5C55.638 61.25 55.75 61.362 55.75 61.5C55.75 61.638 55.638 61.75 55.5 61.75Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.5 55V45.5H61.5V54.5H56",
			fill: "#FEF6AA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.75 55H52.25V45.25H61.75V54.75H56V54.25H61.25V45.75H52.75V55Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5 78.5C37.5 78.5 39.067 78.5 41 78.5C42.933 78.5 44.5 76.933 44.5 75C44.5 73.219 43.165 71.766 41.445 71.545C41.473 71.366 41.5 71.187 41.5 71C41.5 69.067 39.933 67.5 38 67.5C36.968 67.5 36.05 67.955 35.41 68.665C35.026 66.857 33.423 65.5 31.5 65.5C29.291 65.5 27.5 67.291 27.5 69.5C27.5 69.691 27.53 69.874 27.556 70.058C27.128 69.714 26.592 69.5 26 69.5C24.772 69.5 23.755 70.387 23.545 71.555C23.366 71.527 23.187 71.5 23 71.5C21.067 71.5 19.5 73.067 19.5 75C19.5 76.933 21.067 78.5 23 78.5C24.933 78.5 30.5 78.5 30.5 78.5V79H37.5V78.5Z",
			fill: "#FDFCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.25 74C39.112 74 39 73.888 39 73.75C39 72.527 39.995 71.532 41.218 71.532C41.252 71.541 41.955 71.531 42.462 71.668C42.595 71.704 42.674 71.841 42.638 71.974C42.602 72.108 42.465 72.187 42.332 72.15C41.888 72.03 41.232 72.03 41.219 72.032C40.271 72.032 39.5 72.803 39.5 73.75C39.5 73.888 39.388 74 39.25 74Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5 79C32.7761 79 33 78.7761 33 78.5C33 78.2239 32.7761 78 32.5 78C32.2239 78 32 78.2239 32 78.5C32 78.7761 32.2239 79 32.5 79Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41 79H37.5C37.224 79 37 78.776 37 78.5C37 78.224 37.224 78 37.5 78H41C42.654 78 44 76.654 44 75C44 73.504 42.875 72.232 41.382 72.041C41.248 72.023 41.127 71.953 41.046 71.845C40.965 71.737 40.931 71.601 40.952 71.468C40.975 71.314 41 71.16 41 71C41 69.346 39.654 68 38 68C37.15 68 36.362 68.355 35.781 69C35.656 69.139 35.46 69.198 35.281 69.148C35.099 69.099 34.96 68.953 34.921 68.769C34.58 67.165 33.141 66 31.5 66C29.57 66 28 67.57 28 69.5C28 69.643 28.021 69.78 28.041 69.918C28.07 70.121 27.978 70.356 27.799 70.458C27.62 70.56 27.403 70.576 27.243 70.448C26.878 70.155 26.449 70 26 70C25.034 70 24.208 70.691 24.037 71.644C23.989 71.911 23.741 72.09 23.468 72.049C23.314 72.025 23.16 72 23 72C21.346 72 20 73.346 20 75C20 76.654 21.346 78 23 78H30.5C30.776 78 31 78.224 31 78.5C31 78.776 30.776 79 30.5 79H23C20.794 79 19 77.206 19 75C19 72.794 20.794 71 23 71C23.059 71 23.116 71.002 23.174 71.006C23.588 69.82 24.711 69 26 69C26.349 69 26.689 69.061 27.011 69.18C27.176 66.847 29.126 65 31.5 65C33.331 65 34.966 66.127 35.653 67.774C36.333 67.276 37.155 67 38 67C40.206 67 42 68.794 42 71C42 71.048 41.999 71.095 41.996 71.142C43.739 71.59 45 73.169 45 75C45 77.206 43.206 79 41 79Z",
			fill: "#1F4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.5 78C35.341 78 34.659 78 34.5 78C34.224 78 34 78.224 34 78.5C34 78.776 34.224 79 34.5 79C34.659 79 35.341 79 35.5 79C35.776 79 36 78.776 36 78.5C36 78.224 35.776 78 35.5 78Z",
			fill: "#1F4C5C"
		})
	]
});
const ForwardRef = forwardRef(SvgTemplateLibrary);
export { ForwardRef as ReactComponent };
